export const TEMPLATES_LIST_REQUEST = 'TEMPLATES_LIST_REQUEST';
export const TEMPLATES_LIST_SUCCESS = 'TEMPLATES_LIST_SUCCESS';

export const TEMPLATE_DETAILS_REQUEST = 'TEMPLATE_DETAILS_REQUEST';
export const TEMPLATE_DETAILS_SUCCESS = 'TEMPLATE_DETAILS_SUCCESS';
export const TEMPLATE_SAVE_REQUEST = 'TEMPLATE_SAVE_REQUEST';
export const TEMPLATE_SAVE_SUCCESS = 'TEMPLATE_SAVE_SUCCESS';
export const TEMPLATE_DELETE_REQUEST = 'TEMPLATE_DELETE_REQUEST';
export const TEMPLATE_DELETE_SUCCESS = 'TEMPLATE_DELETE_SUCCESS';

export const TEMPLATE_GENERATE_MESSAGE_REQUEST = 'TEMPLATE_GENERATE_MESSAGE_REQUEST';
